import useFetch from '@hooks/useFetch';

export const getKey = (action, resourceType, resourceUid) =>
  `v1/user/check_access/?actions=${action}&resource=${resourceType}:${resourceUid}`;

export const UAM_ACTIONS = {
  PROGRAMME_VIEW: 'Programme:View'
};

export const UAM_RESOURCE_TYPES = {
  PROGRAMME: 'Programme',
  QUIZ: 'QUIZ'
};

const useUAM = (action, resourceType, resourceUid) => {
  const key = getKey(action, resourceType, resourceUid);

  const { data, ...rest } = useFetch(resourceUid ? key : null);

  return {
    key,
    hasAccess: !!data?.actionAllowed?.[action.toLowerCase()],
    data,
    ...rest
  };
};

export default useUAM;
